"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import Managerment from "@/views/managements/Managerment.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, { MenuController } from "@/components/menu/ManagerMenuBar.vue";
import i18n from "@/lang";
import OpenApiMain from "@/views/managements/openapimanager/components/OpenApiMain.vue";
let OpenApiManager = class extends Vue {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "ServiceOptions",
          icon_image: "log_sidebar_1",
          name: i18n.t("open_api.open_api_sidebar_main")
        }
      ],
      "ServiceOptions"
    );
    this.currentGroup = "";
  }
  changeComponent(data) {
    if (data) {
      this.currentGroup = data;
    }
  }
  changeCollapse() {
  }
  created() {
    return __async(this, null, function* () {
      this.currentGroup = "ServiceOptions";
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
};
OpenApiManager = __decorateClass([
  Component({
    components: {
      Managerment,
      MainView,
      UiMenuBar,
      OpenApiMain
    }
  })
], OpenApiManager);
export {
  OpenApiManager as default
};
